<div (click)="onContainerClicked($event)" class="modal fade" tabindex="-1" [ngClass]="{'in': visibleAnimate}"
  [ngStyle]="{'display': visible ? 'block' : 'none', 'opacity': visibleAnimate ? 1 : 0}"
  [class.modal-background-dark]="background === 'dark'"
  [class.modal-background-light]="background === 'light'"
  [class.modal-background-none]="background === 'none'"
  >
  <div class="modal-dialog">
    <div class="modal-content" [style.width]="width" [style.minWidth]="minWidth">
      <div class="modal-body">
        <div class="modal-close" (click)="hide()">
          <span class="fal fa-times"></span>
        </div>
        <ng-content select=".modal-body-content"></ng-content>
      </div>
    </div>
    <div class="modal-dismiss" (click)="hide()">

    </div>
  </div>
</div>